import React from 'react';
import { PropTypes } from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Btn from '../../../components/Btn';

import './signout.css';

export default class SignOut extends React.Component {
    handleSubmit = () => {
        const {
            setAuthToken,
            setSignOutIsVisible,
            isVisible,
        } = this.props;
        setAuthToken(null);
        setSignOutIsVisible(!isVisible);
    }
    toggleSignOutInputVisiblity = () => {
        const { setSignOutIsVisible, isVisible } = this.props;
        setSignOutIsVisible(!isVisible);
    }

    render() {
        const { isVisible } = this.props;
        return (
            <div>
                <Dialog
                    open={isVisible}
                    onClose={(e, value) => this.toggleSignOutInputVisiblity(value)}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogContent>
                        <h3>Confirm Log Out</h3>
                    </DialogContent>
                    <DialogActions>
                        <Btn
                            onClick={(e, value) => this.toggleSignOutInputVisiblity(value)}
                            label="Cancel"
                            color="secondary"
                        />
                        <Btn
                            onClick={(e, value) => this.handleSubmit(value)}
                            label="LOG OUT"
                            color="secondary"
                            type="submit"
                        />
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
SignOut.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    setSignOutIsVisible: PropTypes.func.isRequired,
    setAuthToken: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignOut/SignOut.js